<cdc-simple-header
  [config]="header()"
  (userAction)="onUserAction($event)"
  (brandClick)="onBrandClick($event)"
>
  <!-- Possibilità di aggiungere nav items tramite projection -->
</cdc-simple-header>

